<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Create Password'"
    [canGoBack]="false"
    [noBow]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="recoverPasswordForm">
    <tidy-wrapper>
      <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }" />

      <tidy-card>
        <tidy-row class="field-bottom-padding field-top-padding">
          <tidy-input
            formControlName="password"
            [form]="recoverPasswordForm.controls.password"
            [label]="'Password'"
            [icon]="'assets/svg/lock-closed.svg'"
            [type]="'password'"
            [errorMessage]="'Please enter a password'"
            [submitted]="submitted" />
        </tidy-row>

        <tidy-row>
          <tidy-input
            formControlName="confirm_password"
            [form]="recoverPasswordForm.controls.confirm_password"
            [icon]="'assets/svg/lock-closed.svg'"
            [type]="'password'"
            [errorMessage]="'Please enter a password'"
            [label]="'Confirm password'"
            [submitted]="submitted" />
        </tidy-row>
      </tidy-card>

      <tidy-button
        [text]="'Save Password'"
        [action]="boundOnSubmit"
        class="primary" />

      <tidy-error-message [text]="errorMessage" />

    </tidy-wrapper>
  </form>
</ng-template>

<app-scroll-wrapper [templateContent]="content" />
